import { useTranslation } from '@multaqa/i18n'
import { ConfirmDialog } from '@multaqa/ui/components/ui/confirm-dialog'
import { useDeactivateCustomer } from '../hooks/use-customers'

export function CustomerDeactivateDialog({
  customerId,
  customerCode,
  open,
  onOpenChange,
}: {
  customerId: string
  customerCode: string
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const { t } = useTranslation()
  const deactivate = useDeactivateCustomer()

  const handleDeactivate = () => {
    deactivate.mutate(customerId, {
      onSuccess: () => {
        onOpenChange(false)
      },
    })
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('customer.deactivate')}
      description={t('customer.deactivateConfirmation', { code: customerCode })}
      confirmLabel={t('customer.deactivate')}
      cancelLabel={t('action.cancel')}
      closeLabel={t('action.cancel')}
      tone="destructive"
      pending={deactivate.isPending}
      onConfirm={handleDeactivate}
      testId="customer-deactivate-dialog"
    />
  )
}
